import type { Profile } from 'models';
import { MemberAboutCard, MemberContentLayout, MemberProfileCard, ViewerActions } from '../components';

type P = {
  member: Profile;
};

const CurrentMemberProfile = ({ member }: P) => (
  <MemberContentLayout
    left={<MemberProfileCard actions={<ViewerActions viewer={member} />} member={member} />}
    right={<MemberAboutCard member={member} />}
  />
);

export default CurrentMemberProfile;
